import React, { useState, useCallback, useEffect } from "react";
import Filter from "../../components/Filter/Filter";
import { usePermissionContext } from "../../contexts/permission-context";
import {
    fetchAPIData,
    getCompanyId,
    getToken,
    getUser,
    cleanObject,
    generateHiddenColumns,
    hideSecret,
    HIDDEN_SECRET,
    hasPermission,
    platformManage,
    platformPermissionOptions,
    createFilterOptions, createSortFieldOptions
    // copyToClipboard
} from '../../Utils/Common';
import { handleSave } from '../../components/FormDialog/FormDialog';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Table, { renderCellExpand } from '../../components/Table/Table';
import { GridActionsCellItem } from "@mui/x-data-grid";
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import { Typography } from "@mui/material";
import ActionDialog from "../../components/Dialogs/ActionDialog";
import ConfirmDialog from "../../components/Dialogs/ConfirmDialog";
import axios from 'axios';
import "../pages.scss";
import { usePersistentStorage } from "../../Utils/usePersistentStorage";
import Ajv from "ajv";

import ConnectorSchedulePropertiesPanel from './ConnectorSchedulePropertiesPanel';
const scheduleSchemaCreate = require("../../json/scheduleSchema.json").create.required;
//const scheduleSchemaOptional = require("../../json/scheduleSchema.json").create.optional;
const scheduleSchemaUpdate = require("../../json/scheduleSchema.json").update;

const ajv = new Ajv({ strict: false });

const uiSchema = {
    "connectorConfig": {
        "clientSecret": {
            "ui:widget": "password",
            "ui:autocomplete": "new-password"
        },
        "clientId": {
            "ui:autocomplete": "off"
        },
        "emailIds": {
            "ui:options": {
              orderable: false
            }
        },
    }
};

const ConnectorSchedulesTabPanel = ({ setNotify, createConnectorSchedule, setOpenConnectorSchedule }) => {

    const [apiData, setApiData] = useState([]);
    const { permissions } = usePermissionContext();
    const [rowJsonData, setRowJsonData] = useState({});
    const [open, setOpen] = useState(false);
    const [mode, setMode] = useState('view');  // default to view mode
    const [readOnly, setReadOnly] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);

    const [confirmProps, setConfirmProps] = useState({});

    const [originalClientSecret, setOriginalClientSecret] = useState(""); // store original client secret

    useEffect(() => {
        if (createConnectorSchedule) {
            createConnectorScheduleData();
        }
    }, [createConnectorSchedule]);

    const [connectorSchedules, setConnectorSchedules] = usePersistentStorage("connectorSchedules", []);

    useEffect(() => {
        // check if localstorge had data for the current tab
        setApiData(connectorSchedules);
    }, []);

    const formId = 'ConnectorScheduleDialog';

    const [reload, setReload] = useState(false);

    const [isLoading, setIsloading] = useState(false);

    const DEFAULT_COMPANY_ID = getCompanyId(); // make company dynamic

    const apiURL = `api/companies/${DEFAULT_COMPANY_ID}/connectors/schedules?`;

    const totalLabel = "Matching Schedules";
    const saveButtonText = "Save Connector";

    const fieldData = [
        'scheduleId', 'connectorConfigId', 'description', 'jobState',
        'scheduleSwitch', 'scheduleType', 'createdDate', 'modifiedDate'
    ];

    const hasPlatformManage = hasPermission(permissions, platformManage);

    // note: label is not used or displayed
    const sortFieldData = [
        {
            field: 'scheduleId',
            label: 'Schedule ID'
        },
        // {
        //     field: 'companyId',
        //     label: 'Company ID'
        // },
        {
            field: 'connectorConfigId',
            label: 'Connector Config ID'
        },
        {
            field: 'description',
            label: 'Description'
        },
        {
            field: 'jobState',
            label: 'Job State'
        },
        {
            field: 'scheduleSwitch',
            label: 'Schedule Switch'
        },
        {
            field: 'scheduleType',
            label: 'Schedule Type'
        },
        {
            field: 'createdDate',
            label: 'Created Date'
        },
        {
            field: 'modifiedDate',
            label: 'Modified Date'
        }
    ];


    const columns = [
        // {
        //     field: 'id',
        //     type: 'number',
        //     headerName: 'ID',
        //     hide: true,
        //     minWidth: 50,
        //     flex: 1,
        //     headerAlign: 'left',
        //     align: 'left',
        // },
        {
            field: 'actions',
            type: 'actions',
            hideable:false,
            headerName: 'Actions',
            minWidth: 130,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            getActions: (params) => getActionButtons(params)
        },
        {
            hideable:false,
            field: 'scheduleId',
            headerName: 'Schedule ID',
            minWidth: 320,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            hideable:false,
            field: 'companyId',
            headerName: 'Company ID',
            type: 'number',
            minWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            valueFormatter: (params) => {
                return params.value.toString();
            }
        },
        {
            hideable:false,
            field: 'jobState',
            headerName: 'State',
            minWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            hideable:false,
            field: 'scheduleSwitch', // ???
            headerName: 'On/Off',
            type: 'boolean',
            minWidth: 90,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {
                return (
                    <>
                        {params.value ? 'On' : 'Off'}
                    </>
                );
            }
        },

        {
            hideable:false,
            field: 'connectorType',
            headerName: 'Connector',
            minWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            valueGetter: (params) => params.row.connectorConfig.connectorType
        },
        {
            hideable:false,
            field: 'description',
            headerName: 'Description',
            minWidth: 200,
            maxWidth: 200,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
        },
        {
            hideable:false,
            field: 'lastRunDate',
            headerName: 'Last Run',
            minWidth: 225,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,           // date
        },
        {
            hideable:false,
            field: 'scheduleType',
            headerName: 'Type',
            minWidth: 125,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            hideable:false,
            field: 'schedule',
            headerName: 'Expression',
            minWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
    ];

    const getColumns = () => {
        return (hasPlatformManage && columns) || columns.filter(obj => { return obj.field !== "actions"});
    };

    const toggleColumnPinning = () => {
        return (hasPlatformManage && 'columnPinning') || '';
    };

    const fetchData = async (apiURL2, qparams) => {
        //console.log('inside fetch customer data:', qparams);

        /*
        let message = "Loading customer data ...";
    
        setNotify({
            isOpen: true,
            message: message,
            severity: 'info'
        });
    */
        setIsloading(true);
        await fetchAPIData(apiURL2, qparams)
            .then((data) => {
                //console.log("Updating table data: ", data);
                setApiData(data);
                setConnectorSchedules(data);
                // clear the reload false now that data is loaded
                setReload(false);
                setIsloading(false);
            })
            .catch((err) => {
                console.log(err);

                let message = `Failed to load connector schedules data \n\n ${err.response.statusText} : ${err.response.data.message}`;
                setNotify({
                    isOpen: true,
                    alertTitle: 'Request failed',
                    message: message,
                    severity: 'error'
                });

                // clear data since user may have previously loaded data that is already displayed
                setApiData([]);
                setReload(false);
                setIsloading(false);
            });
    };

    const createConnectorScheduleData = () => {
        let rowData = {};
        const JsonData = rowData;

        setRowJsonData(JsonData);

        setMode('create');

        setOpen(true);
        setReadOnly(false);
    };

    const viewRowData = (param, event) => {

        // remove the id from table data as table data only not part of json stored
        const {
            id,
            ...JsonData
        } = param.row;

        setOriginalClientSecret(JsonData.connectorConfig.clientSecret);

        let formattedData = JSON.parse(JSON.stringify(JsonData)); // make a deep copy to work on

        formattedData.connectorConfig.clientSecret = hideSecret(formattedData.connectorConfig.clientSecret);

        setRowJsonData(formattedData);
        setMode('view');
        setReadOnly(true);
        setOpen(true);
    };

    const viewEditData = useCallback((rowData) => () => {
        // console.log("view/edit icon clicked", rowData);

        // remove the id from table data as table data only not part of json stored
        const {
            id,
            ...JsonData
        } = rowData;

        setOriginalClientSecret(JsonData.connectorConfig.clientSecret);

        let formattedData = JSON.parse(JSON.stringify(JsonData)); // make a deep copy to work on

        formattedData.connectorConfig.clientSecret = hideSecret(formattedData.connectorConfig.clientSecret);

        setRowJsonData(formattedData);
        setMode('edit');
        setReadOnly(false);
        setOpen(true);
    }, []);

    const deleteConnectorSchedule = (companyId, scheduleId) => {

        let deleteUrl = `/api/companies/${companyId}/connectors/schedules/${scheduleId}`;

        axios({
            method: "delete", url: deleteUrl,
            headers: { "insightUserId": getUser(), "companyId": getCompanyId(), "Authorization": getToken() }
        })
            .then(response => {

                let message = `Deleted connector schedule [${scheduleId}]`;

                setNotify({
                    isOpen: true,
                    message: message,
                    severity: 'info'
                });

                // do we need to reload??
                // console.log("current data: ", apiData);
                setApiData([]);
                setReload(true);

            }).catch(error => {
                console.log('error in delete connector schedule api call:', error);

                let message = `Failed to delete connector schedule [${scheduleId}]: \n\n ${error.response.statusText} : ${error.response.data.message}`;

                setNotify({
                    isOpen: true,
                    alertTitle: 'Request failed',
                    message: message,
                    severity: 'error'
                });
            });
    };

    const deleteSchedule = useCallback((rowData) => () => {
        // console.log("delete icon clicked", rowData);

        let scheduleId = rowData.scheduleId;
        let companyId = rowData.companyId;
        let title = "Delete Connector Schedule";

        let msg = `The schedule ${rowData.scheduleId} [${rowData.description}] will be removed. Are you sure?`;

        let confirmProps = {
            title,
            msg,
            confirmCallback: () => deleteConnectorSchedule(companyId, scheduleId)
        };

        setConfirmProps(confirmProps);

        setConfirmOpen(true);
    }, []);


    const enableSchedule = useCallback((rowData) => () => {
        //const enableSchedule = (rowData) => {
        // console.log("enable schedule clicked", rowData);

        let scheduleId = rowData.scheduleId;
        let companyId = rowData.companyId;

        let scheduleSwitch = !rowData.scheduleSwitch;

        let scheduleOnOffTitle = `Turn ${scheduleSwitch ? 'On' : 'Off'} for Schedule`;
        let confirmButtonText = `${scheduleSwitch ? 'Turn On' : 'Turn Off'}`;

        let msg =
            <>
                <Typography variant="body1" paragraph="true">
                    {`Are you sure you want to turn ${scheduleSwitch ? 'on' : 'off'} this connector?`}
                </Typography>
                <Typography variant="body1" paragraph="true">
                    {`[${scheduleId}]`}
                </Typography>
            </>

        let cancelButtonText = "Cancel";

        let confirmProps = {
            title: scheduleOnOffTitle,
            confirmButtonText,
            cancelButtonText,
            msg,
            confirmCallback: () => updateScheduleStatus(companyId, scheduleId, scheduleSwitch)
        };

        setConfirmProps(confirmProps);

        setConfirmOpen(true);


    }, []);

    const updateScheduleStatus = (companyId, scheduleId, scheduleSwitch) => {
        let updateUrl = `/api/companies/${companyId}/connectors/schedules/${scheduleId}/switch/${scheduleSwitch}`;

        axios({
            method: "put", url: updateUrl,
            headers: { "insightUserId": getUser(), "companyId": getCompanyId(), "Authorization": getToken() }
        })
            .then(response => {

                let message = `Updated connector schedule [${scheduleId}] status`;

                setNotify({
                    isOpen: true,
                    message: message,
                    severity: 'info'
                });

                // console.log("current data: ", apiData);
                //setApiData([]);
                setReload(true);

            }).catch(error => {
                console.log('Failed to turn on/off for schedule: ', error);

                let message = `Failed to turn on/off for schedule [${scheduleId}]: \n\n ${error.response.statusText} : ${error.response.data.message}`;

                setNotify({
                    isOpen: true,
                    alertTitle: 'Request failed',
                    message: message,
                    severity: 'error'
                });
            });

    };

    const allowReschedule = useCallback((rowData) => () => {
        // console.log("allow reschedule clicked", rowData);

        let scheduleId = rowData.scheduleId;
        let companyId = rowData.companyId;

        let jobState = "ERROR";

        let title = `Allow Reschedule`;
        let confirmButtonText = `Allow Rescheduling`;

        let msg =
            <>
                <Typography variant="body1" paragraph="true">
                    Are you sure you want to allow rescheduling of this connector?
                </Typography>
                <Typography variant="body1" paragraph="true">
                    {`[${scheduleId}]`}
                </Typography>
            </>

        let cancelButtonText = "Cancel";

        let confirmProps = {
            title,
            confirmButtonText,
            cancelButtonText,
            msg,
            confirmCallback: () => updateJobState(companyId, scheduleId, jobState)
        };

        setConfirmProps(confirmProps);

        setConfirmOpen(true);

    }, []);

    const updateJobState = (companyId, scheduleId, jobState) => {
        let updateUrl = `/api/companies/${companyId}/connectors/schedules/${scheduleId}/jobState/${jobState}`;

        axios({
            method: "put", url: updateUrl,
            headers: { "insightUserId": getUser(), "companyId": getCompanyId(), "Authorization": getToken() }
        })
            .then(response => {

                let message = `Updated connector schedule [${scheduleId}] job state`;

                setNotify({
                    isOpen: true,
                    message: message,
                    severity: 'info'
                });

                //setApiData([]);
                setReload(true);

            }).catch(error => {
                console.log('Failed to update state for schedule: ', error);

                let message = `Failed to update state for schedule [${scheduleId}]: \n\n ${error.response.statusText} : ${error.response.data.message}`;

                setNotify({
                    isOpen: true,
                    alertTitle: 'Request failed',
                    message: message,
                    severity: 'error'
                });
            });
    };

    const getActionButtons = (params) => {
        let actionButtons = [];


        // create edit button
        let editButton = <GridActionsCellItem icon={
            <Tooltip title="Edit" arrow placement="right">
                <EditIcon />
            </Tooltip>}
            label='View/Edit'
            onClick={viewEditData(params.row)}
        />;

        hasPlatformManage && actionButtons.push(editButton);

        let deleteButton = <GridActionsCellItem icon={
            <Tooltip title="Delete" arrow placement="right">
                <DeleteIcon />
            </Tooltip>}
            label='Delete'
            onClick={deleteSchedule(params.row)}
        />;

        hasPlatformManage && actionButtons.push(deleteButton);

        let enableScheduleButton = <GridActionsCellItem
            label='Turn On/Off Schedule'
            onClick={enableSchedule(params.row)}
            showInMenu
        />;

        hasPlatformManage && actionButtons.push(enableScheduleButton);

        let allowRescheduleButton = <GridActionsCellItem
            label='Allow to reschedule'
            onClick={allowReschedule(params.row)}
            showInMenu
        />;

        hasPlatformManage && actionButtons.push(allowRescheduleButton);

        return actionButtons;

    };

    const handleJsonChange = (formData) => {
        // console.log("Dialog JSON has changed", formData);

        setRowJsonData(formData);

    };

    const handleClose = () => {
        setOpen(false);

        setOpenConnectorSchedule(false);
    };

    const handleConfirmClose = () => {
        setConfirmOpen(false);
    };

    const handleFormChange = (data) => {
        setRowJsonData(data.formData);
    }

    const validateSchema = (scheduleSchema, data) => {
        // console.log('got json schema', scheduleSchema);
        const validate = ajv.compile(scheduleSchema);
        const valid = validate(data);
        if (!valid) {
            console.log(validate.errors);
            return false;
        }
        return true;
    }

    const saveConnectorScheduleData = (formData) => {

        // console.log('called save connector schedule:', formData);
        // console.log('current mode:', mode);

        let cleanedObj = cleanObject(formData);

        if (mode === 'edit') {
            if (validateSchema(scheduleSchemaUpdate, cleanedObj)) {
                //call save API
                // console.log('validated successfully..');
                updateConnectorSchedule(cleanedObj);
            } else {
                console.log('update schema validation failed..');
                let message = `Update connector schedule schema validation failed`;

                setNotify({
                    isOpen: true,
                    alertTitle: 'Schema Validation Failure',
                    message: message,
                    severity: 'error'
                });
            }
        }

        if (mode === 'create') {
            if (validateSchema(scheduleSchemaCreate, cleanedObj)) {
                // console.log('create schema validated successfully..');
                createSchedule(cleanedObj);
            }
            else {
                console.log('create schema validation failed..');
                let message = `Create connector schedule schema validation failed`;

                setNotify({
                    isOpen: true,
                    alertTitle: 'Schema Validation Failure',
                    message: message,
                    severity: 'error'
                });
            }

            // reset flag all the time on success or failure
            setOpenConnectorSchedule(false);
        }
    }

    const createSchedule = (data) => {
        try {
            // console.log('inside schedule create api..');

            let createUrl = `/api/companies/${data.companyId}/connectors/schedules`;

            axios({
                method: "post",
                url: createUrl,
                data: data,
                headers: { 'insightUserId': getUser(), 'companyId': getCompanyId(), 'Authorization': getToken() }
            })
                .then(response => {
                    if (response.status === 200) {
                        //console.log('got response from schedule create:', response);

                        let message = `Created connector schedule [${response.data.scheduleId}]`;

                        setNotify({
                            isOpen: true,
                            message: message,
                            severity: 'info'
                        });

                        // refresh the table
                        setReload(true);
                        setOpen(false);
                    }
                }).catch(error => {
                    let message = `Failed to create connector schedule \n\n ${error.response.statusText} : ${error.response.data.message}`;

                    setNotify({
                        isOpen: true,
                        alertTitle: 'Request failed',
                        message: message,
                        severity: 'error'
                    });

                    console.log('error in create schedule api call:', error.response.data.message);
                });
        }
        catch (e) {
            console.log(e);
            let message = `Failed to create connector schedule `;

            setNotify({
                isOpen: true,
                alertTitle: 'Request failed',
                message: message,
                severity: 'error'
            });
        }
    };

    const updateConnectorSchedule = (data) => {
        try {
            // console.log('inside connector schedule update api..');

            // password not changed so send original client secret
            if (data.connectorConfig.clientSecret === HIDDEN_SECRET) {
                data.connectorConfig.clientSecret = originalClientSecret;
            }

            let updateUrl = `/api/companies/${data.companyId}/connectors/schedules/${data.scheduleId}`;

            axios({
                method: "put",
                url: updateUrl,
                data: data,
                headers: { 'insightUserId': getUser(), 'companyId': getCompanyId(), 'Authorization': getToken() }
            })
                .then(response => {
                    if (response.status === 200) {
                        let message = `Updated connector schedule [${data.scheduleId}]`;

                        setNotify({
                            isOpen: true,
                            message: message,
                            severity: 'info'
                        });

                        // console.log('got response from connector schedule update:', response);
                        // refresh the table
                        setReload(true);
                        setOpen(false);
                    }

                }).catch(error => {

                    let message = `Failed to update connector schedule \n\n ${error.response.statusText} : ${error.response.data.message}`;
                    setNotify({
                        isOpen: true,
                        alertTitle: 'Request failed',
                        message: message,
                        severity: 'error'
                    });
                    console.log('error in update connector schedule api call:', error.response.data.message);
                });
        }
        catch (e) {
            console.log(e);
            let message = `Failed to update connector schedule `;
            setNotify({
                isOpen: true,
                alertTitle: 'Request failed',
                message: message,
                severity: 'error'
            });
        }
    };


    return (
        <>
            <div id="connectorSchedulefilterContainer" style={{ marginTop: '0px', marginLeft: '8px' }}>
                <Filter permission={platformPermissionOptions} fields={createFilterOptions(fieldData)} sortFields={createSortFieldOptions(sortFieldData)} apiURL={apiURL} fetchData={fetchData} setNotify={setNotify} reload={reload} useCompanyId={false} totalLabel={totalLabel} tabName={'connectorScheduleTab'} />
            </div>


            <Divider />

            <div id="connectorScheduleTableContainer" className={toggleColumnPinning()} >
                <div>
                    <Table data={apiData} columns={getColumns()} hiddenColumns={generateHiddenColumns(columns)} viewRowData={viewRowData} isLoading={isLoading} />
                </div>
            </div>


            <ActionDialog
                open={open}
                mode={mode}
                onClose={handleClose}
                onSave={() => handleSave(formId, rowJsonData, saveConnectorScheduleData)}
                title="Connector Schedule Information"
                propertiesTabContent={
                    <ConnectorSchedulePropertiesPanel formId={formId}
                        uiSchema={uiSchema}
                        connectorScheduleSchema={mode === 'create' ? scheduleSchemaCreate : scheduleSchemaUpdate}
                        saveConnectorScheduleData={saveConnectorScheduleData}
                        formData={rowJsonData} handleFormChange={handleFormChange}
                        readOnly={readOnly} />
                }
                jsonDataName="connector schedule"
                JSONTabContent={rowJsonData}
                handleJsonChange={handleJsonChange}
                saveButtonText={saveButtonText}
            />

            <ConfirmDialog
                title={confirmProps.title}
                open={confirmOpen}
                onClose={handleConfirmClose}
                setOpen={setConfirmOpen}
                cancelButtonText={confirmProps.cancelButtonText}
                confirmButtonText={confirmProps.confirmButtonText}
                onConfirm={confirmProps.confirmCallback}
            >
                {confirmProps.msg}
            </ConfirmDialog>


        </>
    );
}

export default ConnectorSchedulesTabPanel;